import axios from 'axios';

// Create an axios instance with default config
const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:4000/api',
  timeout: 45000,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Add request interceptor to set bearer token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Enhanced error logging
    console.error('API Error:', {
      url: error.config?.url,
      method: error.config?.method,
      params: error.config?.params,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      message: error.message
    });

    // Handle specific error status codes if needed
    if (error.response) {
      if (error.response.status === 401) {
        // Handle unauthorized access (token expired, etc.)
        localStorage.removeItem('token');
        window.location.href = '/login';
      } else if (error.response.status === 500) {
        // Log detailed server errors
        console.error('Server Error:', error.response.data);
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error('Network Error: No response received', error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Request Configuration Error:', error.message);
    }
    
    return Promise.reject(error);
  }
);

export default api; 